const stackerElement = document.querySelector("dy-stackers")
if (!stackerElement) {
  console.error(
    "dy-stacker-js: No dy-stackers element present in markup on initialization."
  )
} else {
  console.log("dy-stacker-js: preinit found stacker element")
  const shadowRoot = stackerElement.attachShadow({ mode: "open" })
  const htmlElement = document.createElement("html")
  const headElement = document.createElement("head")
  htmlElement.appendChild(headElement)

  const body = document.createElement("body")
  const gender = stackerElement.getAttribute("gender")
  body.className = "StackerPageBody " + gender
  body.dataset.dataCompPrefix = "app_js__"
  htmlElement.appendChild(body)
  shadowRoot.appendChild(htmlElement)

  const isShadow = !("" + window.location.search).includes("noshadow")
  let stackerShadow

  // function insertStyle(styleElement) {
  //   if (!isShadow) {
  //     console.log("Initialized styles to html tag (noshadow mode)")
  //     return document.getElementsByTagName("html")[0]
  //   }
  //   stackerShadow =
  //     stackerShadow ||
  //     Array.from(document.getElementsByTagName("dy-stackers")).map(
  //       (s) => s.shadowRoot || s.attachShadow({ mode: "open" })
  //     )[0]
  //   const root = stackerShadow.querySelector("head")

  //   console.log("Initialized CSS in shadow root")
  //   root.appendChild(styleElement)
  // }

  Object.defineProperty(stackerElement, "__DY_INSERT_STYLE_FN", {
    enumerable: false,
    get() {
      return (styleElement) => {
        if (!isShadow) {
          console.log("Initialized styles to html tag (noshadow mode)")
          return document.getElementsByTagName("html")[0]
        }
        stackerShadow =
          stackerShadow ||
          Array.from(document.getElementsByTagName("dy-stackers")).map(
            (s) => s.shadowRoot || s.attachShadow({ mode: "open" })
          )[0]
        const root = stackerShadow.querySelector("head")

        console.log("Initialized CSS in shadow root")
        root.appendChild(styleElement)
      }
    },
  })

  console.log("dy-stacker-js: preinit added __DY_INSERT_STYLE_FN")
}
